module.exports = __webpack_public_path__ + "img/pending-list.43380990.svg";